<script setup lang="ts">
// DUPLICATED/adapted from packages/frontend/src/modules/shared/components/BattleTacticCard.vue
// for the studio preview. This is a DISPLAY-ONLY SUBSET: all game-state
// tracking (checkboxes, VP syncing, useGameSyncState, recalculateAllVP, useAllGames,
// useMarkdownState) was dropped because the editor preview renders statically.
// Keep the card name, main text, and Affray/Strike/Domination rendering in sync with
// the frontend original; do not re-add the tracking chrome here.
//
// Import rewiring vs original:
//   - formatText → ../utils/formatter.js (local copy)
//   - ContentSection, FontAwesomeIcon, game composables → removed (not needed)
import { type IBattleTacticCard } from '@scrolldex/shared';
import { formatText } from '../utils/formatter.js';

defineProps<{
  card: IBattleTacticCard;
}>();
</script>
<template>
  <div class="battle-tactic-card">
    <div class="header-bar">{{ card.name }}</div>
    <div class="card-content">
      <div v-if="card.text" class="main-text" v-html="formatText(card.text)" />
      <div class="subsection">
        <div class="subheader">Affray - {{ card.affray.name }}</div>
        <div class="subtext" v-html="formatText(card.affray.description)" />
      </div>
      <div class="divider" />
      <div class="subsection">
        <div class="subheader">Strike - {{ card.strike.name }}</div>
        <div class="subtext" v-html="formatText(card.strike.description)" />
      </div>
      <div class="divider" />
      <div class="subsection">
        <div class="subheader">Domination - {{ card.domination.name }}</div>
        <div class="subtext" v-html="formatText(card.domination.description)" />
      </div>
    </div>
  </div>
</template>
<style scoped>
/* Studio-elevation preview. A battle-tactic card keeps its signature gold header
   bar (its identity vs the battleplan card's accent top edge) and raises off the
   surface with a border + shadow. */
.battle-tactic-card {
  background: var(--st-surface);
  border: 1px solid var(--st-border);
  border-radius: var(--st-radius-md);
  box-shadow: var(--st-shadow-2);
  overflow: hidden;
  margin: var(--st-space-3) 0;
}

.header-bar {
  background: #c9a100;
  color: #fff;
  font-weight: var(--st-weight-bold);
  font-size: var(--st-text-md);
  padding: var(--st-space-2) var(--st-space-3);
  letter-spacing: 0.01em;
}

.card-content {
  padding: var(--st-space-3);
}

.main-text {
  margin-bottom: var(--st-space-2);
  color: var(--st-text);
  text-align: left;
}

.subsection {
  margin-bottom: var(--st-space-2);
}

.subheader {
  font-weight: var(--st-weight-bold);
  color: var(--st-text);
  margin-bottom: var(--st-space-1);
  font-size: var(--st-text-md);
}

.subtext {
  color: var(--st-text-muted);
  margin-bottom: var(--st-space-1);
  font-size: var(--st-text-sm);
  text-align: left;
}

.divider {
  height: 1px;
  background: var(--st-border);
  margin: var(--st-space-2) 0;
}
</style>
